import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// Axios instance for public endpoints (no JWT auth or idle-timeout interceptors)
const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export default publicApi;
